import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const CreditCardIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        d="M1 9C1 6.23858 3.23858 4 6 4H23V15C23 17.7614 20.7614 20 18 20H1V9Z"
        fill={getColor(secondaryColor)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.65 14.875C23.65 18.1059 21.0309 20.725 17.8 20.725L0.349995 20.725L0.349996 8.60001C0.349996 5.36914 2.96913 2.75 6.2 2.75L23.65 2.75001L23.65 14.875ZM17.8 19.025C20.092 19.025 21.95 17.167 21.95 14.875L21.95 4.45001L6.2 4.45C3.90801 4.45 2.05 6.30802 2.05 8.60001L2.05 19.025L17.8 19.025Z"
        fill="currentColor"
      />
      <path d="M1.20001 8.25H22.8V10.65H1.20001V8.25Z" fill="currentColor" />
    </BaseIcon>
  );
};

export default CreditCardIconFilled;
